import { render } from "./LoginPage.vue?vue&type=template&id=38b4326a&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=38b4326a&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/KhamSucKhoe_NewVersion/KhamSucKhoe_FE_newVersion/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__